import { render, staticRenderFns } from "./Newfhkbody.vue?vue&type=template&id=61c3d792&scoped=true&"
import script from "./Newfhkbody.vue?vue&type=script&lang=js&"
export * from "./Newfhkbody.vue?vue&type=script&lang=js&"
import style0 from "./Newfhkbody.vue?vue&type=style&index=0&id=61c3d792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3d792",
  null
  
)

export default component.exports